<div class="goreact-modal rate-limit-dialog">
	<div class="goreact-modal-header">
		<h4 [id]="data.dialogTitleId" class="modal-title" translate="rate-limit-dialog_title"></h4>
	</div>
	<div class="goreact-modal-body" cdkTrapFocus>
		<img class="graphic" [src]="activeBrandService.getImage('upside-down-astronaut.svg')" alt="Too many requests">
		<p
			class="text"
			[innerHTML]="'rate-limit-dialog_message' | translate:
				{ 'time': countdown$ | async}">
		</p>
	</div>
</div>
